// This class contains form mapping logic for disclosure form
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'

export default class DisclosureForm extends FormMapping {
	constructor(planHolderId: string) {
		super(planHolderId)
	}

	getFormMappings() {
		return [
			...this.getPolicyOwnerMapping(),
			...this.getProposedInsuredMapping(),
			...this.getFuneralHomeMapping(),
			...this.getFuneralHomeRepresentativeMappings(),
		]
	}
}
